module.exports = __webpack_public_path__ + "img/dskbank.a42aaecd.png";